import './styles.scss';
import React from 'react';
import DateUtils from '../../../../services/DateUtils';
import RSVP_CONSTS from '../../../../constants';
import { GeckoIcon, GeckoLabel } from '@geckolabs/gecko-react-ui';

const renderDate = (start, end) => {
    return DateUtils.isSameDay(start, end) ? DateUtils.dayMonthDateYear(start) : `${DateUtils.dateMonthYearHourMinute(start)} - ${DateUtils.dateMonthYearHourMinute(end)}`;
};

const renderTime = (start, end) => {
    return DateUtils.isSameDay(start, end) ? `${DateUtils.hourMinute(start)} - ${DateUtils.hourMinute(end)}` : null;
};

export const SessionDescription = ({session, attendance}) => {
    const title = (
        <div className="session-description-title">
            {session.title}
        </div>
    );
    const date = (
        <div className="session-description-meta">
            <GeckoIcon icon="calendar-alt" /> 
            &nbsp;
            {renderDate(session.start_datetime, session.end_datetime)}
        </div>
    );
    const time = renderTime(session.start_datetime, session.end_datetime) ? (
        <div className="session-description-meta">
            <GeckoIcon icon="clock" /> 
            &nbsp;
            {renderTime(session.start_datetime, session.end_datetime)}
        </div>
    ) : null;
    const status = attendance ? (
        <div className="session-description-status">
            <GeckoLabel 
                name={(
                    <>
                        <GeckoIcon icon={RSVP_CONSTS.ATTENDANCE.ICONS[attendance.status]} /> 
                        &nbsp;
                        {RSVP_CONSTS.ATTENDANCE.TITLES[attendance.status]}
                    </>
                )} type={RSVP_CONSTS.ATTENDANCE.TITLE_TYPES[attendance.status]} 
            />
        </div>
    ) : null;

    return (
        <div className="session-description">
            <div className="session-description-info flex-column d-flex justify-content-center">
                <div>
                    {title}
                    {date}
                    {time}
                    {status}
                </div>
            </div>
        </div>
    );
};

export default SessionDescription;